// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"359":"lineminiapp","360":"developer","443":"about","721":"kaishuu"}[chunkId] + "." + {"359":"51ec1df3","360":"1fb4a4b5","443":"1a843477","721":"8ecb3f68"}[chunkId] + ".js";
};